import React, { useEffect, useState } from 'react';
import CartIcon from '../../icons/cart';
import { Link } from 'react-router-dom';
import AddToCart from '../AddToCart';
import BookCarousel from '../BookCarousel';


export default function BookPage() {

  document.title = `The History of the Dolls and What They Did by Jesse Ball | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `The questions of animacy and reality that hover over childhood are given new thrust in the absurdist writer Jesse Ball’s playdate horror, The History of the Dolls and What They Did.`);


  return (<div className='newPageContainer'>
    <div className='productContainer'>
      <div className='productImage_container  '>
        <div className='productCarousel'>
          <BookCarousel images={['../../Series-Three/JesseBall_07_Mockup1.webp', '../../Series-Three/JesseBall_07_Mockup2.webp', '../../Series-Three/JesseBall_07_Mockup3.webp']} start={1} />
        </div>
      </div>
      <div className='productInfo_container'>
        <div className='productInfo_inner'>
          <div className='productInfo'>
            <h1 className='productTitle'>The History of the Dolls and What They Did</h1>
            <div className='productAuthor'>Jesse Ball</div>
          </div>
          <div className='productBuyControls'>
            <AddToCart context={'product'} id={'9798990416567'} />
            <div className='productPrice'>$14.99 USD</div>
          </div>
          <div className='productExcerpt'>
            How it will go is this, said Vivian; we have to find out what the dolls are planning, and we seem to be getting nowhere. Let’s play a game where we try to catch the dolls in a lie. Whoever catches more lies will win. Abigail agreed to the stakes.

          </div>

          <div className='productDescription'>The questions of animacy and reality that hover over childhood are given new thrust in the absurdist writer Jesse Ball’s playdate horror, <em>The History of the Dolls and What They Did</em>. Set within a home nursery, Ball’s short story follows two young girls into a world of clipped agency and brute amusement that mimes the cruelties of our own. Accompanied by spare illustrations, The History of the Dolls is a breathtaking fable of chorality and control with many a perspectival shift. For fans of <em>Suspiria</em> and Shirley Jackson.
          </div>
          <div className='productDescription'>
            <p>
              <strong>Jesse Ball</strong> is an American author of tersely compelling and avidly experimental texts. His prolific and award-winning work ranges from short stories to poems and novels (most recently, <em>The Repeat Room</em>, 2024) that have been translated into more than twenty languages. Ball is on the faculty of the University of Virginia.
            </p>
            <p><em>Back cover photo: Lin Woldendorp</em></p>
          </div>
          <div className='productMetadata'>
            <div>Series III, No. 7</div>
            <div>Summer 2025</div>
            <div>ISBN 979–8–990416–56–7</div>
            <div>4.125 x 2.75 inches</div>
            <div>128 Pages</div>
          </div>
        </div>
      </div>
    </div>
  </div>)
}